// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1wOzc","title":"BackImages_title__2Q4iJ","images":"BackImages_images__2zLXR"};